module.exports = __webpack_public_path__ + "img/logonew_en.cb0c426b.png";